import {NgModule} from '@angular/core';
import {SharedModule} from "../../../shared.module";
import {CartProductSummaryComponent} from "./cart-product-summary.component";
import {AoUpsellModule} from "../../ao-cart/ao-upsell/ao-upsell.module";

@NgModule({
    imports: [
        SharedModule,
        AoUpsellModule
    ],
    exports: [
        CartProductSummaryComponent
    ],
    declarations: [CartProductSummaryComponent]
})
export class CartProductSummaryModule {
}
